export * from './authentications.service';
import { AuthenticationsService } from './authentications.service';
export * from './version.service';
import { VersionService } from './version.service';
export const APIS = [AuthenticationsService, VersionService];
